import { C1Text, C4Text } from "../../../common/components/text/CustomText";
import { Container, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import Translate from "../../../common/translate/Translate";
import { CustomTable, LinkTd, StatusBadge } from "../../../common/components/table/CustomTable";
import { useEffect, useState } from "react";
import { TicketDetailModal } from "../../ticket/modals/TicketDetailModal";
import UIUtil from "../../../common/utils/UIUtil";
import { Theme } from "../../../common/Theme";
import TicketService from "../../../service/TicketService";

function RemainTicketListDashboardCard() {
    const service = new TicketService();
    const [ticketList, setTicketList] = useState([]);
    const [ticketTotal, setTicketTotal] = useState(0);

    const fetchTicketList = () => {
        service
            .getTicketList({ page: 1, pageSize: 12, remained: "true" })
            .then((result) => {
                setTicketList(result.ticketInfo ?? []);
                setTicketTotal(result.page?.totalElements ?? 0);
            })
            .catch((error) => {
                console.error("Error fetching remain ticket list:", error);
            });
    };

    useEffect(() => {
        fetchTicketList();
    }, []);
    const [detailDto, setDetailDto] = useState({
        ticketNo: "",
        shopName: "",
        issueType: "",
        customerName: "",
        contact: "",
        detail: "",
        status: "Registered",
        recipient: "",
        device: { deviceNumber: "-", type: "-", model: "-", deviceId: "-" },
        registeredDate: "",
        memo: [
            { text: "hello1", createdAt: "2025-08-09 12:00:25" },
            { text: "hello2", createdAt: "2025-08-04" },
        ],
    });
    const [saveMode, setSaveMode] = useState(false);
    const [openDetailModal, setOpenDetailModal] = useState(false);

    const tableHeaders = [
        {
            key: "ticketNo",
            label: Translate("ticket.ticketNo"),
            render: (row) => (
                <LinkTd
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setDetailDto({
                            ticketNo: "00001",
                            shopName: "Shop 01",
                            shopCode: "LGF001",
                            issueType: "Symptoms",
                            customerName: "Kim",
                            contact: "010-1234-1234",
                            detail: "The issue is coming",
                            status: "Closed",
                            recipient: "Sitanun",
                            device: {
                                deviceNumber: "W001",
                                type: "Washer",
                                model: "FH069FD_T",
                                deviceId: "84960297-c1fa-16b3-a339-60ab148ff8e8",
                            },
                            registeredDate: "2025-08-09 12:00:25",
                            memo: [],
                        });
                        setSaveMode(false);
                        setOpenDetailModal(true);
                    }}
                >
                    {row.ticketNo}
                </LinkTd>
            ),
        },
        {
            key: "shopCode",
            label: Translate("store.shopCode"),
        },
        {
            key: "shopName",
            label: Translate("store.shopName"),
        },
        {
            key: "issueType",
            label: Translate("ticket.type"),
        },
        {
            key: "status",
            label: "Status",
            render: (row) => {
                const { textColor, backgroundColor, text } = UIUtil.getTicketStatusUI(row.status);

                return (
                    <StatusBadge backgroundColor={backgroundColor} color={textColor}>
                        {text}
                    </StatusBadge>
                );
            },
        },
        {
            key: "recipient",
            label: "Recipient",
        },
        {
            key: "registeredDate",
            label: "Registered Date",
        },
    ];

    return (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={"473px"}
            alignItem={"flex-start"}
            justifyContent={"flex-start"}
            padding={"16px"}
            backgroundColor={"transparent"}
        >
            <Row>
                <C1Text>Remain Ticket List</C1Text>
                <SizedBox width={"8px"} />
                <Container padding={"4.5px 10px"} borderRadius={"50px"} border={`1px solid ${Theme.color.neutral200}`}>
                    <C4Text fontColor={Theme.color.zinc850} fontWeight={"400"}>
                        {ticketTotal}
                    </C4Text>
                </Container>
            </Row>
            <SizedBox height={"12px"} />
            <CustomTable headers={tableHeaders} data={ticketList} />
            {openDetailModal && (
                <TicketDetailModal
                    isOpen={openDetailModal}
                    onClose={() => setOpenDetailModal(false)}
                    dto={detailDto}
                    isSaveMode={saveMode}
                    side={"right"}
                />
            )}
        </SizedBox>
    );
}

export default RemainTicketListDashboardCard;
